export default __webpack_public_path__ + "static/media/hp-5.340cb29b.png";